import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-accent-400">g点网</span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              {t('siteDescription')}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" title="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" title="微信">
                <i className="ri-wechat-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('quickLinks')}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors">{t('home')}</Link></li>
              <li><Link to="/category/platform-news" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors">平台资讯</Link></li>
              <li><Link to="/category/usage-guide" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors">使用指南</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors">{t('about')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('categories')}</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-400 hover:text-accent-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('contactUs')}</h4>
            <ul className="space-y-2.5 text-sm text-secondary-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                <span>{siteInfo.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                <span>{siteInfo.workingHours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-500">
              &copy; {new Date().getFullYear()} g点网 {t('allRightsReserved')}
            </p>
            <div className="flex items-center gap-4 text-xs text-secondary-500">
              <a href="#" className="hover:text-accent-400 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-accent-400 transition-colors">服务条款</a>
              <a href="#" className="hover:text-accent-400 transition-colors">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}